import { render, staticRenderFns } from "./test-again-dialog.vue?vue&type=template&id=23062516"
import script from "./test-again-dialog.vue?vue&type=script&lang=js"
export * from "./test-again-dialog.vue?vue&type=script&lang=js"
import style0 from "./test-again-dialog.vue?vue&type=style&index=0&id=23062516&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports